import { Button, Flex, Image } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, Pages, SecondaryLayoutData } from "~/core";
import { getLinkPropsFromAction } from "~/core/utils/action.utils";
import { isButtonVariant } from "~/features/headerV4/isButtonVariant";
import { useDirectus } from "~/shared/utils/directus/useDirectus";
import { getPictureData } from "~/shared/utils/get-picture-data";

/**
 *   Header для Secondary Layout заполняется из коллекции secondary_layout
 */

export type SecondaryHeaderData = SecondaryLayoutData;
export type SecondaryHeaderProps = {
  data: SecondaryHeaderData;
  onCallAction: (action: Action) => void;
  isActionInactive: (control: Action) => boolean;
  getUrl: (page: Pages) => string;
};
export const SecondaryHeader: FC<SecondaryHeaderProps> = ({
  data,
  isActionInactive,
  onCallAction,
  getUrl,
}) => {
  const { getDirectusImage } = useDirectus();
  const headerLogo = getPictureData(data?.logo);
  return (
    <Flex
      align="center"
      justify="space-between"
      p={{ py: 12, px: 16 }}
      position={{ type: "fixed", top: 0, left: 0, right: 0, zIndex: 20 }}
      bg="background-tetriary"
    >
      <Image
        value={getDirectusImage(headerLogo.id, {
          width: headerLogo.mWidth ? headerLogo.mWidth * 2 : undefined,
          height: headerLogo.mHeight ? headerLogo.mHeight * 2 : undefined,
          format: "webp",
          quality: 85,
        })}
        image={{
          alt: headerLogo.altText ?? "",
        }}
        width={headerLogo.mWidth}
        height={headerLogo.mHeight}
        mdValue={getDirectusImage(headerLogo.mdId, {
          width: headerLogo.mdWidth ? headerLogo.mdWidth * 2 : undefined,
          height: headerLogo.mdHeight ? headerLogo.mdHeight * 2 : undefined,
          format: "webp",
          quality: 85,
        })}
        md={{ width: headerLogo.mdWidth, height: headerLogo.mdHeight }}
        dValue={getDirectusImage(headerLogo.dId, {
          width: headerLogo.dWidth ? headerLogo.dWidth * 2 : undefined,
          height: headerLogo.dHeight ? headerLogo.dHeight * 2 : undefined,
          format: "webp",
          quality: 85,
        })}
        d={{ width: headerLogo.dWidth, height: headerLogo.dHeight }}
      />
      <Flex align="center" justify="space-between" gap={12}>
        {data.header_actions?.map((item) => {
          const buttonText =
            item?.secondary_layout_header_actions_id?.translations?.[0]
              ?.action_text;
          const controlAction =
            item?.secondary_layout_header_actions_id?.action;
          const {
            isInactive,
            href,
            handlePress: handlePressButton,
          } = getLinkPropsFromAction({
            onCallAction,
            getUrl,
            controlAction,
            isActionInactive,
          });

          const variant = isButtonVariant(
            item?.secondary_layout_header_actions_id?.action_variant,
          )
            ? item?.secondary_layout_header_actions_id?.action_variant
            : "default";

          return (
            !isInactive && (
              <Button
                href={href}
                onPress={handlePressButton}
                key={item?.id}
                size="xsmall"
                fontSize="button.mobile.xsmall"
                fontWeight="mobile.bold"
                lineHeight="button.mobile.xsmall"
                border={{
                  radius: "button",
                }}
                p={{
                  py: 8,
                  px: 12,
                }}
                variant={variant}
              >
                {buttonText}
              </Button>
            )
          );
        })}
      </Flex>
    </Flex>
  );
};
